// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.AppMenu {
    text-align: right;
    cursor: default;
    transition: background-color 0.25s;
    outline: none;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: right;
    height: 100%;
    flex: 0 1 20em;
}

div.AppMenu.appmenu-nolabel {
    flex: 0 0 auto;
}

div.AppMenu.appmenu-visible {
    background-color: var(--app-submenu-bg-color-hover);
    color: var(--app-submenu-text-color-hover);
    overflow: visible;
}

div.AppMenu .appmenu-button {
    display: flex;
    align-items: center;
}

div.AppMenu .appmenu-label {
    font-weight: bold;
    transition: color 0.25s;
    color: var(--app-menu-text-color);
}

div.AppMenu.appmenu-visible .appmenu-label {
    color: var(--app-submenu-text-color-hover);
}

div.AppMenu .appmenu-icon > span.icon {
    color: var(--app-menu-text-color);
    padding: 0.25em;
    margin: 0 1em;
    border: 2px solid var(--app-menu-text-color);
    transition: color 0.25s, border-color 0.25s, background-color 0.25s;
}

div.AppMenu.appmenu-visible .appmenu-icon > span.icon {
    color: var(--app-submenu-text-color-hover);
    border-color: var(--app-submenu-text-color-hover);
    background-color: inherit;
}

div.AppMenu.appmenu-blocked {
    cursor: not-allowed;
}

div.AppMenu div.appmenu-menu-container {
    position: absolute;
    top: 100%;
    right: 0;
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    width: 20em;
    max-width: 100vw;
    opacity: 0;
    transform-origin: top;
    transform: scaleY(0);
    transition: transform 0.25s, opacity 0.25s;
    overflow-y: auto;
    max-height: calc(var(--plugins-container-height) - var(--topbar-height) - var(--bottombar-height));
}

div.AppMenu.appmenu-compact div.appmenu-menu-container {
    right: -11.25em;
    width: 15em;
    height: calc(var(--plugins-container-height) - var(--topbar-height) - var(--bottombar-height));
    transition: transform 0.25s, opacity 0.25s, right 0.5s;
    background: var(--app-menu-bg-color);
    box-shadow: 0px 0px 4px rgba(136, 136, 136, 0.5);
    top: 3.5em;
}

div.AppMenu.appmenu-compact div.appmenu-menu-container:hover,
div.AppMenu.appmenu-compact div.appmenu-menu-container:focus-within {
    right: 0;
}

div.AppMenu div.appmenu-menu {
    background-color: var(--app-menu-bg-color);
    text-align: left;
    font-size: small;
}

div.AppMenu.appmenu-visible div.appmenu-menu-container {
    transform: scaleY(1);
    opacity: 1;
}

div.appmenu-menu-item {
    display: flex;
    align-items: center;
    color: var(--app-menu-text-color);
    font-weight: bold;
}

div.appmenu-menu-item:not(:last-child) {
    border-bottom: 1px solid var(--app-menu-text-color);
}

div.appmenu-menu-item > .icon {
    width: 2em;
    margin: 0.5em 1em 0.5em 1em;
}

div.appmenu-menu-item-label {
    margin: 0.25em 0;
}

div.appmenu-menu-item-comment {
    font-weight: normal;
    font-size: 90%;
}

div.appmenu-submenu-active,
div.appmenu-submenu-expanded {
    background-color: var(--app-menu-bg-color-hover);
    color: var(--app-menu-text-color-hover);
}

div.appmenu-menu-item-nested {
    background-color: var(--app-submenu-bg-color);
    color: var(--app-submenu-text-color);
}

div.appmenu-menu-item:focus-within {
    background-color: var(--app-menu-bg-color-hover);
    color: var(--app-menu-text-color-hover);
    outline: none;
}

div.appmenu-menu-item-nested:focus-within {
    background-color: var(--app-submenu-bg-color-hover);
    color: var(--app-submenu-text-color-hover);
}

div.appmenu-menu-item-filter {
    padding-right: 0.5em;
}

div.appmenu-menu-item-filter > div.input-container {
    flex: 1 1 auto;
}
`, "",{"version":3,"sources":["webpack://./components/style/AppMenu.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mDAAmD;IACnD,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,4CAA4C;IAC5C,mEAAmE;AACvE;;AAEA;IACI,0CAA0C;IAC1C,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gDAAgD;IAChD,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,kGAAkG;AACtG;;AAEA;IACI,eAAe;IACf,WAAW;IACX,8FAA8F;IAC9F,sDAAsD;IACtD,oCAAoC;IACpC,gDAAgD;IAChD,UAAU;AACd;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,gDAAgD;IAChD,uCAAuC;AAC3C;;AAEA;IACI,6CAA6C;IAC7C,oCAAoC;AACxC;;AAEA;IACI,gDAAgD;IAChD,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,mDAAmD;IACnD,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["div.AppMenu {\n    text-align: right;\n    cursor: default;\n    transition: background-color 0.25s;\n    outline: none;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: right;\n    height: 100%;\n    flex: 0 1 20em;\n}\n\ndiv.AppMenu.appmenu-nolabel {\n    flex: 0 0 auto;\n}\n\ndiv.AppMenu.appmenu-visible {\n    background-color: var(--app-submenu-bg-color-hover);\n    color: var(--app-submenu-text-color-hover);\n    overflow: visible;\n}\n\ndiv.AppMenu .appmenu-button {\n    display: flex;\n    align-items: center;\n}\n\ndiv.AppMenu .appmenu-label {\n    font-weight: bold;\n    transition: color 0.25s;\n    color: var(--app-menu-text-color);\n}\n\ndiv.AppMenu.appmenu-visible .appmenu-label {\n    color: var(--app-submenu-text-color-hover);\n}\n\ndiv.AppMenu .appmenu-icon > span.icon {\n    color: var(--app-menu-text-color);\n    padding: 0.25em;\n    margin: 0 1em;\n    border: 2px solid var(--app-menu-text-color);\n    transition: color 0.25s, border-color 0.25s, background-color 0.25s;\n}\n\ndiv.AppMenu.appmenu-visible .appmenu-icon > span.icon {\n    color: var(--app-submenu-text-color-hover);\n    border-color: var(--app-submenu-text-color-hover);\n    background-color: inherit;\n}\n\ndiv.AppMenu.appmenu-blocked {\n    cursor: not-allowed;\n}\n\ndiv.AppMenu div.appmenu-menu-container {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n    width: 20em;\n    max-width: 100vw;\n    opacity: 0;\n    transform-origin: top;\n    transform: scaleY(0);\n    transition: transform 0.25s, opacity 0.25s;\n    overflow-y: auto;\n    max-height: calc(var(--plugins-container-height) - var(--topbar-height) - var(--bottombar-height));\n}\n\ndiv.AppMenu.appmenu-compact div.appmenu-menu-container {\n    right: -11.25em;\n    width: 15em;\n    height: calc(var(--plugins-container-height) - var(--topbar-height) - var(--bottombar-height));\n    transition: transform 0.25s, opacity 0.25s, right 0.5s;\n    background: var(--app-menu-bg-color);\n    box-shadow: 0px 0px 4px rgba(136, 136, 136, 0.5);\n    top: 3.5em;\n}\n\ndiv.AppMenu.appmenu-compact div.appmenu-menu-container:hover,\ndiv.AppMenu.appmenu-compact div.appmenu-menu-container:focus-within {\n    right: 0;\n}\n\ndiv.AppMenu div.appmenu-menu {\n    background-color: var(--app-menu-bg-color);\n    text-align: left;\n    font-size: small;\n}\n\ndiv.AppMenu.appmenu-visible div.appmenu-menu-container {\n    transform: scaleY(1);\n    opacity: 1;\n}\n\ndiv.appmenu-menu-item {\n    display: flex;\n    align-items: center;\n    color: var(--app-menu-text-color);\n    font-weight: bold;\n}\n\ndiv.appmenu-menu-item:not(:last-child) {\n    border-bottom: 1px solid var(--app-menu-text-color);\n}\n\ndiv.appmenu-menu-item > .icon {\n    width: 2em;\n    margin: 0.5em 1em 0.5em 1em;\n}\n\ndiv.appmenu-menu-item-label {\n    margin: 0.25em 0;\n}\n\ndiv.appmenu-menu-item-comment {\n    font-weight: normal;\n    font-size: 90%;\n}\n\ndiv.appmenu-submenu-active,\ndiv.appmenu-submenu-expanded {\n    background-color: var(--app-menu-bg-color-hover);\n    color: var(--app-menu-text-color-hover);\n}\n\ndiv.appmenu-menu-item-nested {\n    background-color: var(--app-submenu-bg-color);\n    color: var(--app-submenu-text-color);\n}\n\ndiv.appmenu-menu-item:focus-within {\n    background-color: var(--app-menu-bg-color-hover);\n    color: var(--app-menu-text-color-hover);\n    outline: none;\n}\n\ndiv.appmenu-menu-item-nested:focus-within {\n    background-color: var(--app-submenu-bg-color-hover);\n    color: var(--app-submenu-text-color-hover);\n}\n\ndiv.appmenu-menu-item-filter {\n    padding-right: 0.5em;\n}\n\ndiv.appmenu-menu-item-filter > div.input-container {\n    flex: 1 1 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
